import * as React from 'react'
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from 'reactstrap'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

import { logoutUser } from '../../src/auth/index.web'
import { translate } from '../../src/i18n'

interface IProfileDropdown {
  firstName: string
  lastName: string
  title: string
}

const ProfileDropdown: React.FC<IProfileDropdown> = (props) => {
  // *variable declarations
  const [showDropDown, showDropDownHandler] = React.useState(false)
  const dispatch = useDispatch()

  // * custom methods
  const toggleDropDown = () => {
    showDropDownHandler(!showDropDown)
  }

  const gotoProfile = () => {
    dispatch(push('/profile'))
  }

  const logout = () => {
    dispatch(logoutUser())
  }

  const changePassword = () => {
    dispatch(push('/change-password'))
  }
  return (
    <>
      <Dropdown isOpen={showDropDown} toggle={toggleDropDown}>
        <DropdownToggle className={'profile-dropdown text-capitalize'}>
          {' '}
          <label className="d-inline-block mr-1">
            <span style={{ color: 'white' }}>
              {`${props.firstName} ${props.lastName}`}&#160;</span>
            <span className="title d-block"> {props.title}</span>
          </label>
          <em style={{ color: 'white' }} className="fa fa-caret-down" />
        </DropdownToggle>
        <DropdownMenu className={''}>
          <DropdownItem onClick={gotoProfile}>
            {translate('navDropDown.profile')}
          </DropdownItem>
          <DropdownItem onClick={changePassword}>
            {translate('navDropDown.changePassword')}
          </DropdownItem>
          <DropdownItem onClick={logout}>
            {translate('navDropDown.logout')}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default ProfileDropdown
